import { forwardRef } from 'react';
import { motion } from 'framer-motion';

interface SectionDividerProps {
  variant?: 'wave' | 'fade' | 'glow';
  className?: string;
}

export const SectionDivider = forwardRef<HTMLDivElement, SectionDividerProps>(function SectionDivider({ variant = 'fade', className = '' }, ref) {
  if (variant === 'wave') {
    return (
      <div className={`relative h-10 md:h-14 overflow-hidden ${className}`} aria-hidden="true">
        <svg
          className="absolute bottom-0 w-full h-full"
          viewBox="0 0 1440 80"
          preserveAspectRatio="none"
          fill="none"
        >
          <path
            d="M0,40 C360,80 720,0 1080,40 C1260,60 1380,50 1440,40 L1440,80 L0,80 Z"
            className="fill-background/50"
          />
          <path
            d="M0,50 C320,10 640,70 960,30 C1120,10 1300,50 1440,40 L1440,80 L0,80 Z"
            className="fill-background/30"
          />
        </svg>
      </div>
    );
  }

  if (variant === 'glow') {
    return (
      <div className={`relative flex items-center justify-center py-4 md:py-6 ${className}`} aria-hidden="true">
        <motion.div
          className="h-px w-full max-w-md bg-gradient-to-r from-transparent via-primary/30 to-transparent"
          initial={{ scaleX: 0, opacity: 0 }}
          whileInView={{ scaleX: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
        <motion.div
          className="absolute h-8 w-32 rounded-full bg-primary/8 blur-2xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        />
      </div>
    );
  }

  if (variant === 'fade') {
    return (
      <div className={`h-4 md:h-6 ${className}`} aria-hidden="true">
        <div className="h-full w-full divider-gradient opacity-60" />
      </div>
    );
  }

  // default fallback
  return (
    <div className={`h-4 md:h-6 ${className}`} aria-hidden="true">
      <div className="h-full w-full divider-gradient opacity-60" />
    </div>
  );
});
